export const statusFacturar = {
  pendiente: 'PENDIENTE',
  entregado: 'ENTREGADO',
  rechazado: 'RECHAZADO'
};

export const regimenFiscalList = [
  { Codigo: '601', Valor: 'General de Ley Personas Morales' },
  { Codigo: '603', Valor: 'Personas Morales con Fines no Lucrativos' },
  { Codigo: '605', Valor: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { Codigo: '606', Valor: 'Arrendamiento' },
  { Codigo: '607', Valor: 'Régimen de Enajenación o Adquisición de Bienes' },
  { Codigo: '608', Valor: 'Demás ingresos' },
  { Codigo: '609', Valor: 'Consolidación' },
  { Codigo: '610', Valor: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
  { Codigo: '611', Valor: 'Ingresos por Dividendos (socios y accionistas)' },
  { Codigo: '612', Valor: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { Codigo: '614', Valor: 'Ingresos por intereses' },
  { Codigo: '615', Valor: 'Régimen de los ingresos por obtención de premios' },
  { Codigo: '616', Valor: 'Sin obligaciones fiscales' },
  { Codigo: '620', Valor: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
  { Codigo: '621', Valor: 'Incorporación Fiscal' },
  { Codigo: '622', Valor: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
  { Codigo: '623', Valor: 'Opcional para Grupos de Sociedades' },
  { Codigo: '624', Valor: 'Coordinados' },
  {
    Codigo: '625',
    Valor: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'
  },
  { Codigo: '626', Valor: 'Régimen Simplificado de Confianza' },
  { Codigo: '628', Valor: 'Hidrocarburos' },
  { Codigo: '629', Valor: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
  { Codigo: '630', Valor: 'Enajenación de acciones en bolsa de valores' }
];

export const formaPagoList = [
  { Codigo: '01', Valor: 'Efectivo' },
  { Codigo: '02', Valor: 'Cheque nominativo' },
  { Codigo: '03', Valor: 'Transferencia electrónica de fondos' },
  { Codigo: '04', Valor: 'Tarjeta de crédito' },
  { Codigo: '05', Valor: 'Monedero electrónico' },
  { Codigo: '06', Valor: 'Dinero electrónico' },
  { Codigo: '08', Valor: 'Vales de despensa' },
  { Codigo: '12', Valor: 'Dación en pago' },
  { Codigo: '13', Valor: 'Pago por subrogación' },
  { Codigo: '14', Valor: 'Pago por consignación' },
  { Codigo: '15', Valor: 'Condonación' },
  { Codigo: '17', Valor: 'Compensación' },
  { Codigo: '23', Valor: 'Novación' },
  { Codigo: '24', Valor: 'Confusión' },
  { Codigo: '25', Valor: 'Remisión de deuda' },
  { Codigo: '26', Valor: 'Prescripción o caducidad' },
  { Codigo: '27', Valor: 'A satisfacción del acreedor' },
  { Codigo: '28', Valor: 'Tarjeta de débito' },
  { Codigo: '29', Valor: 'Tarjeta de servicios' },
  { Codigo: '30', Valor: 'Aplicación de anticipos' },
  { Codigo: '31', Valor: 'Intermediario pagos' },
  { Codigo: '99', Valor: 'Por definir' }
];

export const usoCFDI_List = [
  { Codigo: 'D01', Valor: 'Honorarios médicos, dentales y gastos hospitalarios.' },
  { Codigo: 'D02', Valor: 'Gastos médicos por incapacidad o discapacidad' },
  { Codigo: 'D03', Valor: 'Gastos funerales.' },
  { Codigo: 'D04', Valor: 'Donativos.' },
  { Codigo: 'D05', Valor: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).' },
  { Codigo: 'D06', Valor: 'Aportaciones voluntarias al SAR.' },
  { Codigo: 'D07', Valor: 'Primas por seguros de gastos médicos.' },
  { Codigo: 'D08', Valor: 'Gastos de transportación escolar obligatoria.' },
  { Codigo: 'D09', Valor: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.' },
  { Codigo: 'D10', Valor: 'Pagos por servicios educativos (colegiaturas)' },
  { Codigo: 'G01', Valor: 'Adquisición de mercancias' },
  { Codigo: 'G02', Valor: 'Devoluciones, descuentos o bonificaciones' },
  { Codigo: 'G03', Valor: 'Gastos en general' },
  { Codigo: 'I01', Valor: 'Construcciones' },
  { Codigo: 'I02', Valor: 'Mobilario y equipo de oficina por inversiones' },
  { Codigo: 'I03', Valor: 'Equipo de transporte' },
  { Codigo: 'I04', Valor: 'Equipo de computo y accesorios' },
  { Codigo: 'I05', Valor: 'Dados, troqueles, moldes, matrices y herramental' },
  { Codigo: 'I06', Valor: 'Comunicaciones telefónicas' },
  { Codigo: 'I07', Valor: 'Comunicaciones satelitales' },
  { Codigo: 'I08', Valor: 'Otra maquinaria y equipo' },
  { Codigo: 'P01', Valor: 'Por definir' }
];
